/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetOrgsOptions, AdminGetOrgsStatus200, AdminGetOrgsStatus422 } from '../models/AdminGetOrgs'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetOrgs } from '../clients/axios/adminGetOrgs'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetOrgsQueryKey = ({ query }: Omit<AdminGetOrgsOptions, 'headers'> = {}) => [{ url: '/admin/orgs' }, ...(query ? [query] : [])] as const

type AdminGetOrgsQueryKey = ReturnType<typeof adminGetOrgsQueryKey>

export function adminGetOrgsQueryOptions({ query }: AdminGetOrgsOptions = {}, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetOrgsQueryKey({ query })
  return queryOptions<AdminGetOrgsStatus200, ResponseErrorConfig<AdminGetOrgsStatus422>, AdminGetOrgsStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetOrgs({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary List Orgs
 * {@link /admin/orgs}
 */
export function useAdminGetOrgs<TData = AdminGetOrgsStatus200, TQueryData = AdminGetOrgsStatus200, TQueryKey extends QueryKey = AdminGetOrgsQueryKey>({ query }: { query?: AdminGetOrgsOptions['query'] | (() => AdminGetOrgsOptions['query']) } = {}, options: {
  query?: Partial<QueryObserverOptions<AdminGetOrgsStatus200, ResponseErrorConfig<AdminGetOrgsStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? adminGetOrgsQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetOrgsQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetOrgsStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
